module.exports = __webpack_public_path__ + "static/media/rev-ncube-gray.a4b1bf8b.jpg";